import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { DownloadActivityProvider } from "@/components/downloads";
// Import the adapters directly: the feature barrels pull whole pages (and their CSS) into the entry chunk.
import { modelExportDownloadAdapter } from "@/features/models/exportDownloadAdapter";
import { datasetDownloadAdapters } from "@/features/datasets/downloadAdapter";
import "./eager-styles";
import { routes } from "./routes";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } });
// The signed-in identity and server capabilities change only at sign-in or on a deployment (sign-out reloads the page);
// a page mounting them again reuses the shell's read. Mutations that change them still invalidate.
for (const path of ["/api/me", "/api/capabilities"]) queryClient.setQueryDefaults(["get", path], { staleTime: 5 * 60_000 });
const downloadAdapters={...datasetDownloadAdapters,model_export:modelExportDownloadAdapter};
const router = createBrowserRouter(routes);

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DownloadActivityProvider adapters={downloadAdapters}><RouterProvider router={router} /></DownloadActivityProvider>
    </QueryClientProvider>
  );
}
